// src/components/FaqBlock.jsx
export default function FaqBlock() {
  const faqs = [
    {
      q: 'Puis-je payer à la livraison ?',
      a: 'Oui, vous pouvez choisir le paiement à la livraison (COD) lors de la validation de votre commande.',
    },
    {
      q: 'Quels moyens de paiement acceptez-vous ?',
      a: 'Nous acceptons PayGate (Flooz / TMoney) et le paiement à la livraison selon les zones.',
    },
    {
      q: 'Livrez-vous en dehors de Lomé ?',
      a: 'Oui, la livraison hors Lomé est possible sur demande, avec des frais adaptés à la zone.',
    },
    {
      q: 'Comment suivre ma commande ?',
      a: 'Après validation, vous recevez un numéro de commande et un lien de suivi pour voir l’avancement.',
    },
  ]

  return (
    <section className="mb-5">
      <div className="card-modern p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="m-0">Questions fréquentes</h3>
          <a
            href="https://wa.me/22899740138"
            target="_blank"
            rel="noreferrer"
            className="btn btn-soft btn-sm"
          >
            Une question ? WhatsApp
          </a>
        </div>

        <div className="faq-list">
          {faqs.map((item, idx) => (
            <details key={idx} className="mb-2">
              <summary className="fw-semibold small">
                {item.q}
              </summary>
              <div className="text-muted small mt-1">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}
